import { FC, useCallback } from "react";
import { useAppDispatch, useAppSelector } from "@/store/hooks";
import { normalizedCostWidgetSetupVisualizationSelector } from "@/store/dashboards/selectors/setups/normalized-cost-widget/visualization/normalizedCostWidgetSetupVisualizationSelector";
import { normalizedCostWidgetVisualizationChangeThunk } from "@/store/dashboards/thunks/widgets/normalized-cost-widget/setup-change/normalizedCostWidgetVisualizationChangeThunk";
import { ResourceExplorerChartScale } from "@/store/resource-explorer/utils/types/billingExplorer";
import { ChartScaleSelect } from "@/storybook/c8r-highcharts/common/components/ChartScaleSelect";

export const NormalizedCostWidgetScaleSelect: FC = () => {
  const dispatch = useAppDispatch();
  const scale =
    useAppSelector(normalizedCostWidgetSetupVisualizationSelector)?.scale ??
    "linear";

  const changeHandler = useCallback(
    (scale: ResourceExplorerChartScale) => {
      dispatch(
        normalizedCostWidgetVisualizationChangeThunk({
          scale,
        }),
      );
    },
    [dispatch],
  );

  return <ChartScaleSelect scale={scale} onScaleChange={changeHandler} />;
};
